import styled, { keyframes } from 'styled-components';

export interface Props {}

const dash = keyframes`
	0% {
		stroke-dasharray: 1, 786;
		stroke-dashoffset: 0;
	}

	50% {
		stroke-dasharray: 700, 786;
		stroke-dashoffset: -0;
	}

	100% {
		stroke-dasharray: 700, 786;
		stroke-dashoffset: -736;
	}
`;

const rotate = keyframes`
	100% {
		transform: rotate(360deg);
	}
`;

const elements = {
	loader: styled.div`
		display: flex;
		font-size: 2em;

		svg {
			animation: ${rotate} 2s linear infinite;
		}

		svg circle {
			stroke-linecap: round;
			animation: ${dash} 3.5s ease-in-out infinite;
		}
	`,
	svg: styled.svg`
		display: inline-block;
		width: 1em;
		height: 1em;
		font-size: inherit;
		vertical-align: text-top;
		fill: currentColor;
		stroke: currentColor;
		pointer-events: none;
	`,
};

export function Spinner(): JSX.Element {
	return (
		<elements.loader data-testid='loading-spinner'>
			<elements.svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'>
				<circle cx='128' cy='128' r='118' fill='none' strokeWidth='7%'></circle>
			</elements.svg>
		</elements.loader>
	);
}
